import React from 'react';

// Two login surfaces rendered as overlays:
//   - Front-desk sign-in gate (full-screen modal, shown until FD auth
//     completes — blocks all interaction).
//   - Admin key (bottom-right floating pill, expands to a password
//     field when clicked).
export default function LoginGates({
  // FD gate
  frontdeskAuth,
  authHydrated = true,
  fdPassword,
  setFdPassword,
  fdLoginError,
  setFdLoginError,
  handleFrontdeskLogin,
  // Admin inline
  adminMode,
  loginVisible,
  setLoginVisible,
  password,
  setPassword,
  adminLoginError,
  setAdminLoginError,
  handleLogin,
  playClickSound,
  inputRef,
  loginTimeoutRef,
}) {
  return (
    <>
      {!frontdeskAuth && authHydrated && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
          style={{ backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)' }}
        >
          <div data-allow-interaction className="w-96 bg-white text-black rounded-lg p-6 shadow-xl">
            <h3 className="text-lg font-semibold mb-3">Please sign in</h3>
            <form
              onSubmit={async e => {
                e.preventDefault();
                setFdLoginError('');
                const r = await handleFrontdeskLogin(fdPassword, true);
                if (r.success) { setFdPassword(''); setFdLoginError(''); }
                else setFdLoginError(r.message || 'Invalid password');
              }}
            >
              <input
                type="password"
                name="fd-password"
                autoComplete="current-password"
                className="w-full border p-2 rounded mb-3 text-black"
                placeholder="Front-desk password"
                value={fdPassword}
                onChange={e => { setFdPassword(e.target.value); setFdLoginError(''); }}
              />
              {fdLoginError && <p className="text-red-600 text-xs mb-2">{fdLoginError}</p>}
              <div className="flex gap-2">
                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Sign In</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {frontdeskAuth && !adminMode && (
        <div className="fixed bottom-4 right-4 z-60">
          {!loginVisible ? (
            <button
              data-allow-interaction
              onClick={() => { playClickSound(); setLoginVisible(true); setTimeout(() => inputRef.current?.focus(), 300); }}
              className="w-12 h-12 bg-white text-black rounded-full shadow-lg flex items-center justify-center hover:bg-gray-200 transition-all duration-300"
            >
              🔑
            </button>
          ) : (
            <div data-allow-interaction className="w-64 bg-white text-black border shadow-lg rounded-lg p-4 flex flex-col items-start animate-fade-in">
              <label className="text-sm font-semibold mb-1">Admin Password</label>
              <form className="w-full" onSubmit={e => { e.preventDefault(); handleLogin(); }}>
                <input
                  type="password"
                  name="admin-password"
                  autoComplete="current-password"
                  ref={inputRef}
                  className="border p-2 rounded w-full mb-2 text-black"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setAdminLoginError('');
                    if (loginTimeoutRef.current) clearTimeout(loginTimeoutRef.current);
                    loginTimeoutRef.current = setTimeout(() => {
                      setLoginVisible(false);
                      setPassword('');
                      setAdminLoginError('');
                    }, 10000);
                  }}
                />
                {adminLoginError && <p className="text-red-600 text-xs mb-2">{adminLoginError}</p>}
                <button type="submit" data-allow-interaction className="bg-blue-600 text-white px-4 py-1 rounded w-full">Login</button>
              </form>
            </div>
          )}
        </div>
      )}
    </>
  );
}
